const DEFAULT_UPLOADS_URL = "https://uploads.b3.fun";
const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/gif", "image/webp"];
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
/**
 * Upload a file to the B3 uploads service (Cloudflare R2).
 * Returns the public URL of the uploaded asset.
 */
export async function uploadFile(file, options) {
    if (!ALLOWED_TYPES.includes(file.type)) {
        throw new Error(`Invalid file type. Allowed: ${ALLOWED_TYPES.join(", ")}`);
    }
    if (file.size > MAX_FILE_SIZE) {
        throw new Error(`File too large. Maximum size: ${MAX_FILE_SIZE / 1024 / 1024}MB`);
    }
    const uploadsUrl = options?.baseUrl || DEFAULT_UPLOADS_URL;
    const formData = new FormData();
    formData.append("file", file);
    const res = await fetch(`${uploadsUrl}/upload/image`, {
        method: "POST",
        body: formData,
    });
    if (!res.ok) {
        const body = await res.json().catch(() => ({ success: false, error: "Upload failed" }));
        throw new Error(body.error || `Upload failed (${res.status})`);
    }
    const body = await res.json().catch(() => ({ success: false, error: "Invalid response" }));
    if (!body.success || !body.data) {
        throw new Error(body.error || "Upload failed");
    }
    return body.data.url;
}
